<script setup lang="ts">
import ButtonOutlined from '@/shared/components/button/ButtonOutlined.vue';
import ProgressSteps from './ProgressStepsTrack.vue';
import ProgressStepsList from './ProgressStepsList.vue';
import ChevronUpSVG from '@shared/assets/icon/chevron-up.svg';

defineProps<{ visible: boolean }>();
const emit = defineEmits<(e: 'update:visible', value: boolean) => void>();
const close = () => emit('update:visible', false);
</script>

<template>
  <a-drawer
    class="com-overlay-container"
    :visible="visible"
    :mask="false"
    :body-style="{ padding: 0 }"
    :closable="false"
    width="100vw"
    height="100vh"
    placement="top"
  >
    <div class="steps__overlay com-screen">
      <ProgressSteps />
      <div class="content">
        <ProgressStepsList class="steps-list" @navigateAway="close" />
        <ButtonOutlined @click="close" block>
          Close
          <template #iconRight>
            <ChevronUpSVG />
          </template>
        </ButtonOutlined>
      </div>
    </div>
  </a-drawer>
</template>

<style lang="less" scoped>
.steps__overlay {
  background-color: @color-mid-tone;
  height: 100%;
}

.content {
  padding-top: 20px;
}

.steps-list {
  margin-top: 20px;
  margin-bottom: 50px;
}
</style>
